/**
 * simple hook that returns boolean value if a project is uuid based, uuidEmailNonUnique, or uuidEmailUnique
 * */

import { useSelector } from 'react-redux';

import { UuidProjectType, selectIsUuidBasedProject, selectUuidProjectType } from 'core/userContext';

export const useUuidBasedProject = () => {
  const isUuidProject = useSelector(selectIsUuidBasedProject);
  const isEmailNonUnique =
    isUuidProject && useSelector(selectUuidProjectType) === UuidProjectType.EmailNonUnique;
  const isEmailUnique =
    isUuidProject && useSelector(selectUuidProjectType) === UuidProjectType.EmailUnique;

  return {
    isUuidProject,
    isEmailNonUnique,
    isEmailUnique,
  };
};
